import type { BlockDefinition, HeadingProps } from '../types';
import { escapeHtml } from '../html';

/**
 * Heading. Plain title text — H1/H2/H3 + alignment. No verified badge:
 * verified is identity-bearing and lives only on `instagram-bio`, where
 * it sits inline next to the @username (the standard social pattern).
 */
export const heading: BlockDefinition<HeadingProps> = {
  type: 'heading',
  meta: {
    label: 'Heading',
    icon: '🅷',
    category: 'content',
    description: 'Title text — H1/H2/H3 with alignment.',
  },
  defaults: () => ({
    text: 'Your name',
    level: 1,
    align: 'center',
  }),
  validate(input) {
    const i = (input ?? {}) as Partial<HeadingProps>;
    const level = i.level === 1 || i.level === 2 || i.level === 3 ? i.level : 1;
    const align = ['left', 'center', 'right'].includes(i.align as string)
      ? (i.align as HeadingProps['align'])
      : 'center';
    return {
      text: typeof i.text === 'string' ? i.text.slice(0, 200) : '',
      level,
      align,
    };
  },
  render(props) {
    const sizePx = props.level === 1 ? 28 : props.level === 2 ? 22 : 18;
    const weight = props.level === 1 ? 700 : 600;
    return `<div class="pb-block pb-heading" style="text-align:${props.align};">
  <h${props.level} style="font-size:${sizePx}px;line-height:1.2;font-weight:${weight};color:var(--text);margin:0;">${escapeHtml(props.text)}</h${props.level}>
</div>`;
  },
};
